import { Close } from '@mui/icons-material';
import { Box, IconButton, MenuItem, SxProps, Theme } from '@mui/material';
import Select from '@/common/presentation/components/inputs/Select';
import type { OptionType } from '../hook/useERPEquipmentSelector';

interface EquipmentClearableSelectProps {
  options: OptionType[];
  value: OptionType | null;
  onChange: (value: OptionType | null) => void;
  disabled?: boolean;
  label: string;
  placeholder: string;
  sx?: SxProps<Theme>;
  required?: boolean;
  error?: boolean;
  helperText?: string;
}

export function EquipmentClearableSelect({
  options,
  value,
  onChange,
  disabled,
  label,
  placeholder,
  sx,
  required,
  error,
  helperText,
  ...rest
}: EquipmentClearableSelectProps & Record<string, unknown>) {
  const isValueInOptions = value?.id != null && options.some((option) => option.id === value.id);
  const selectValue = isValueInOptions ? value.id : '';

  return (
    <Box sx={{ position: 'relative' }}>
      <Select
        fullWidth
        disabled={disabled}
        value={selectValue}
        onChange={(event) => {
          const selectedId = event.target.value;
          const selectedOption = options.find((option) => option.id === selectedId) || null;
          onChange(selectedOption);
        }}
        label={label}
        placeholder={placeholder}
        required={required}
        error={error}
        helperText={helperText}
        sx={sx}
        {...rest}
      >
        {options.map((option) => (
          <MenuItem key={option.id} value={option.id ?? ''}>
            {option.name || ''}
          </MenuItem>
        ))}
      </Select>
      {value && (
        <IconButton
          size="small"
          onClick={() => onChange(null)}
          sx={{
            position: 'absolute',
            right: 32,
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 1
          }}
        >
          <Close fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
}
